import * as types from './studyLocation.types'

export const actions = {
  toggleLoading: payload => ({
    type: types.TOGGLE_LOADING,
    payload,
  }),
  toggleSuccess: payload => ({
    type: types.TOGGLE_SUCCESS,
    payload,
  }),
  set: payload => ({
    type: types.SET_STUDY_LOCATION,
    payload,
  }),
  create: payload => ({
    type: types.CREATE_STUDY_LOCATION,
    payload,
  }),
  get: payload => ({
    type: types.GET_STUDY_LOCATION,
    payload,
  }),
  edit: payload => ({
    type: types.EDIT_STUDY_LOCATION,
    payload,
  }),
  delete: payload => ({
    type: types.DELETE_STUDY_LOCATION,
    payload,
  }),
  getOptions: () => ({
    type: types.GET_OPTIONS,
  }),
  setOptions: payload => ({
    type: types.SET_OPTIONS,
    payload,
  }),
  clearData: () => ({
    type: types.CLEAR_DATA,
  }),
  setPermissions: payload => ({
    type: types.SET_PERMISSIONS,
    payload,
  }),
  setCanBeCreated: payload => ({
    type: types.SET_CAN_BE_CREATED,
    payload,
  }),
  setErrors: payload => ({
    type: types.SET_ERRORS,
    payload,
  }),
}
